<template>
  <div
    v-if="hasSocialLinks"
    class="fast-footer-social tw-flex tw-justify-center md:tw-justify-end tw-gap-2"
  >
    <!-- Facebook -->
    <QBtn
      v-if="facebookId"
      :href="getFooterFacebookLink(facebookId)"
      type="a"
      target="_blank"
      title="facebook-link"
      round
      outline
      class="fast-social-button"
      @click="eventFooterSocial('facebook', getFooterFacebookLink(facebookId))"
    >
      <QIcon name="fa-brands fa-square-facebook" :size="iconSize" />
    </QBtn>

    <!-- Instagram -->
    <QBtn
      v-if="instagramId"
      :href="getInstagramLink(instagramId)"
      type="a"
      target="_blank"
      title="instagram-link"
      round
      outline
      class="fast-social-button"
      @click="eventFooterSocial('instagram', getInstagramLink(instagramId))"
    >
      <QIcon name="fa-brands fa-instagram" :size="iconSize" />
    </QBtn>

    <!-- WhatsApp -->
    <QBtn
      v-if="whatsappId"
      :href="getWhatsAppLink(whatsappId)"
      title="whatsapp-link"
      type="a"
      target="_blank"
      round
      outline
      class="fast-social-button"
      @click="eventFooterSocial('whatsapp', getWhatsAppLink(whatsappId))"
    >
      <QIcon name="fa-brands fa-whatsapp" :size="iconSize" />
    </QBtn>

    <!-- Line -->
    <QBtn
      v-if="lineId"
      :href="getLineLink(lineId)"
      type="a"
      target="_blank"
      title="line-link"
      round
      outline
      class="fast-social-button"
      @click="eventFooterSocial('line', getLineLink(lineId))"
    >
      <QIcon name="fa-brands fa-line" :size="iconSize" />
    </QBtn>

    <!-- YouTube -->
    <QBtn
      v-if="youtubeLink"
      :href="youtubeLink"
      title="youtube-link"
      type="a"
      target="_blank"
      round
      outline
      class="fast-social-button"
      @click="eventFooterSocial('youtube', youtubeLink)"
    >
      <QIcon name="fa-brands fa-youtube" :size="iconSize" />
    </QBtn>

    <!-- TikTok -->
    <QBtn
      v-if="tiktokLink"
      :href="tiktokLink"
      title="tiktok-link"
      type="a"
      target="_blank"
      round
      outline
      class="fast-social-button"
      @click="eventFooterSocial('tiktok', tiktokLink)"
    >
      <QIcon name="fa-brands fa-tiktok" :size="iconSize" />
    </QBtn>
  </div>
</template>

<script setup lang="ts">
const props = withDefaults(defineProps<{
  iconSize?: string;
}>(), {
  iconSize: '18px',
});

// Access Nuxt app and store
const { getInstagramLink, getWhatsAppLink, getLineLink } =
  useSocialLink();

const getFooterFacebookLink = (id: string): string => {
  return `https://www.facebook.com/${id}`;
};

// Social media links
const contactStore = useContactStore();
const { facebookId, instagramId, whatsappId, lineId, youtubeLink, tiktokLink } =
  storeToRefs(contactStore);

// Check if any social links exist
const hasSocialLinks = computed(
  () =>
    facebookId.value ||
    instagramId.value ||
    lineId.value ||
    whatsappId.value ||
    youtubeLink.value ||
    tiktokLink.value,
);

// Analytics event tracking
const { analyticEvent, fbPixelEvent } = useAnalytic();
const eventFooterSocial = (social: string, url: string) => {
  analyticEvent({
    ga4ActionName: `click_cta_footer_${social}`,
    ga4Label: url,
  });
  fbPixelEvent({
    fbCategory: 'trackCustom',
    fbEvent: 'Footer - Social',
    fbValue: { label: url },
  });
};

const iconSize = computed(() => props.iconSize);
</script>

<style lang="scss" scoped>
.fast-social-button {
  @apply tw-flex tw-h-10 tw-w-10 tw-min-w-0 tw-items-center tw-justify-center tw-border tw-border-light-gray-2;
  border-radius: 9999px !important;
  transition: all 0.3s ease;
}

.fast-social-button::before {
  border-radius: 9999px !important;
}

.fast-social-button :deep(.q-focus-helper),
.fast-social-button :deep(.q-btn__content) {
  border-radius: 9999px !important;
}
</style>
